import { makeStyles } from 'tss-react/mui';

const CHECKBOX_COLUMN_WIDTH = '5%';

const useStyles = makeStyles()((theme) => ({
  containedRoot: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    minWidth: 0,
  },
  description: {
    flexShrink: 0,
    paddingBottom: '16px',
    color: theme.new.color.textSecondary,
  },
  tableWrapper: {
    '& > div:first-of-type': {
      marginBottom: 0,
    },
  },
  tableWrapperContained: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  table: {
    marginBottom: 0,
    minHeight: 0,
    '& .MuiPaper-elevation': {
      boxShadow: theme.new.boxShadows?.elevation1 ?? 'none',
      borderRadius: '12px',
      border: `1px solid ${theme.new.color.line.hairline}`,
    },
    '& .table-container': {
      borderBottom: `1px solid ${theme.new.color.line.hairline}`,
    },
    '& .MuiCheckbox-root': {
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: 22,
        fill: theme.new.color.line.border,
      },
      '&.Mui-checked .MuiSvgIcon-root': {
        fill: theme.new.color.brand[600],
        color: theme.new.color.common.white,
      },
      '&.Mui-focusVisible .MuiSvgIcon-root': {
        fill: theme.new.color.brand[600],
      },
    },
    '& .select-all-checkbox-header': {
      width: CHECKBOX_COLUMN_WIDTH,
      '& .Mui-TableHeadCell-Content': {
        justifyContent: 'center',
      },
    },
  },
  tableContained: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    '& #table-list-view': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiPaper-root': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    '& .MuiTableContainer-root': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
    },
    '& .table-container': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      overflowY: 'auto',
      overflowX: 'auto',
      borderBottom: `1px solid ${theme.new.color.line.hairline}`,
    },
    '& .MuiTablePagination-root': {
      flexShrink: 0,
    },
    '& .mobileViewWidget': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
    },
  },
}));

export default useStyles;
